export type TSimulacaoEntryPoint = 'espelho-de-vendas' | 'simulacao-rapida'

export type TSimulacaoEntryPointConfig = {
  tipo: TSimulacaoEntryPoint
  basePath: '/espelho-de-vendas' | '/es-CL/espelho-de-vendas' | '/es-CL/simulacao-rapida'
  breadcrumbLabelKey:
    | 'lista_empreendimentos.breadcrumb.espelho_de_vendas'
    | 'lista_empreendimentos.breadcrumb.simulacao_rapida'
  tituloKey: 'lista_empreendimentos.titulo'
  subtituloKey?: string
  simuladorPath: '/simulador'
  simulacoesTitulo: 'lista_empreendimentos.simulacoes.espelho_de_vendas.titulo' | 'lista_empreendimentos.simulacoes.simulacao_rapida.titulo'
  simulacoesSubtitulo:
    | 'lista_empreendimentos.simulacoes.espelho_de_vendas.subtitulo'
    | 'lista_empreendimentos.simulacoes.simulacao_rapida.subtitulo'
}

export const simulacaoEntryPointConfigByType: Record<TSimulacaoEntryPoint, TSimulacaoEntryPointConfig> = {
  'espelho-de-vendas': {
    tipo: 'espelho-de-vendas',
    basePath: '/es-CL/espelho-de-vendas',
    breadcrumbLabelKey: 'lista_empreendimentos.breadcrumb.espelho_de_vendas',
    tituloKey: 'lista_empreendimentos.titulo',
    simuladorPath: '/simulador',
    simulacoesTitulo: 'lista_empreendimentos.simulacoes.espelho_de_vendas.titulo',
    simulacoesSubtitulo: 'lista_empreendimentos.simulacoes.espelho_de_vendas.subtitulo',
  },
  'simulacao-rapida': {
    tipo: 'simulacao-rapida',
    basePath: '/es-CL/simulacao-rapida',
    breadcrumbLabelKey: 'lista_empreendimentos.breadcrumb.simulacao_rapida',
    tituloKey: 'lista_empreendimentos.titulo',
    simuladorPath: '/simulador',
    simulacoesTitulo: 'lista_empreendimentos.simulacoes.simulacao_rapida.titulo',
    simulacoesSubtitulo: 'lista_empreendimentos.simulacoes.simulacao_rapida.subtitulo',
  },
}

export const defaultSimulacaoEntryPointConfig = simulacaoEntryPointConfigByType['espelho-de-vendas']

export const getSimulacaoEntryPointConfig = (entryPoint: TSimulacaoEntryPoint): TSimulacaoEntryPointConfig => {
  return simulacaoEntryPointConfigByType[entryPoint]
}

export const resolveSimulacaoEntryPointConfig = (input?: {
  entryPointConfig?: TSimulacaoEntryPointConfig
}): TSimulacaoEntryPointConfig => {
  if (input?.entryPointConfig) return input.entryPointConfig
  return defaultSimulacaoEntryPointConfig
}
